module.exports = __webpack_public_path__ + "static/img/hnrm.3818aa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hnrm.png
// module id = +D54
// module chunks = 0